export default {
  common: {
    signOut: 'ログアウト'
  },
  views: {
    login: {
      memberId: '会員ID',
      birthday: '生年月日',
      signIn: 'ログイン',
      invalidLogin: '会員IDまたは生年月日が間違っています。'
    },
    memberInfo: {
      information: '会員情報',
      memberType: '会員種類',
      memberID: '会員 ID',
      validity: '有効期間',
      useHistory: '利用履歴',
      ticketUsage: 'チケット利用',
      logout: 'ログアウト'
    }
  },
  validation: {
    required: '{{name}}を入力してください',
    requiredSelect: '選択してください',
    invalid: '有効な{{name}}を入力してください',
    password: '大文字、小文字、記号、数字を組み合わせた8文字以上で作成ください',
    number: '半角数字を入力してください'
  }
};
